import { render, staticRenderFns } from "./SimplePage.vue?vue&type=template&id=1ea5ca7d&scoped=true&"
import script from "./SimplePage.vue?vue&type=script&lang=js&"
export * from "./SimplePage.vue?vue&type=script&lang=js&"
import style0 from "./SimplePage.vue?vue&type=style&index=0&id=1ea5ca7d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea5ca7d",
  null
  
)

export default component.exports